import React from "react";
import { withStyles } from "material-ui/styles";
import { Button, Select, MenuItem } from "material-ui";
import { FormGroup, FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";

import CTable, {
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";

import CInput from "uis/CInput";

import ErrorMessage from "components/ErrorMessage";

const styles = theme => {
  return {
    dialogTitle: {
      width: 800
    },
    errorMessage: {
      fontSize: ".9rem",
      margin: "10px 30px 0"
    },
    dialogContent: {
      paddingTop: 0
    },
    deleteBtnDiv: {
      textAlign: "right"
    },
    deleteBtn: {
      margin: "10px 0",
      backgroundColor: theme.palette.remove.dark,
      "&:hover": {
        backgroundColor: theme.palette.remove.light
      }
    },
    customerNameyInput: {
      width: 310
    },
    industryInput: {
      width: 310
    },
    employeesInput: {
      width: 90
    },
    memo: {
      margin: "5px 0 15px"
    }
  };
};

class CustomerModal extends React.Component {
  render() {
    const {
      classes,
      customerModal,
      allLocales,
      title,
      btnLabel,
      industries
    } = this.props;
    const { open, customer, errors } = customerModal;
    // action
    const {
      changeCustomerForm,
      changeSelectedLocales,
      handleClose,
      handleRegister,
      handleUpdate,
      handleDelete
    } = this.props;

    const isNew = customer.isNew();

    return (
      <Dialog open={open}>
        <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>

        <ErrorMessage messages={errors} className={classes.errorMessage} />

        <DialogContent className={!isNew ? classes.dialogContent : ""}>
          {!isNew && (
            <div className={classes.deleteBtnDiv}>
              <Button
                raised
                dense
                className={classes.deleteBtn}
                onClick={handleDelete(customer)}
              >
                削除
              </Button>
            </div>
          )}

          <CTable>
            <CTableBody>
              {customer.customerKey && (
                <CTableRow>
                  <CHeadCell>顧客ID</CHeadCell>
                  <CBodyCell>{customer.customerKey}</CBodyCell>
                </CTableRow>
              )}

              <CTableRow>
                <CHeadCell>顧客名 *</CHeadCell>
                <CBodyCell>
                  <CInput
                    id="customer-name"
                    value={customer.customerName}
                    onChange={e =>
                      changeCustomerForm("customerName", e.target.value)
                    }
                    className={classes.customerNameyInput}
                  />
                </CBodyCell>
              </CTableRow>

              <CTableRow>
                <CHeadCell>産業分類(大分類) *</CHeadCell>
                <CBodyCell>
                  <Select
                    value={customer.industryParentId}
                    onChange={e =>
                      changeCustomerForm("industryParentId", e.target.value)
                    }
                    input={
                      <CInput
                        name="industry-type"
                        id="industry-type"
                        className={classes.industryInput}
                      />
                    }
                  >
                    {industries.large.map(industry => (
                      <MenuItem key={industry.id} value={industry.id}>
                        {industry.name}
                      </MenuItem>
                    ))}
                  </Select>
                </CBodyCell>
              </CTableRow>

              <CTableRow>
                <CHeadCell>産業分類(中分類) *</CHeadCell>
                <CBodyCell>
                  <Select
                    value={customer.industryId}
                    onChange={e =>
                      changeCustomerForm("industryId", e.target.value)
                    }
                    input={
                      <CInput
                        name="industry-type"
                        id="industry-type"
                        className={classes.industryInput}
                      />
                    }
                  >
                    {industries.middle
                      .filter(v => v.parentId === customer.industryParentId)
                      .map(industry => (
                        <MenuItem key={industry.id} value={industry.id}>
                          {industry.name}
                        </MenuItem>
                      ))}
                  </Select>
                </CBodyCell>
              </CTableRow>

              <CTableRow>
                <CHeadCell>従業員数 *</CHeadCell>
                <CBodyCell>
                  <CInput
                    id="customer-employees"
                    value={customer.employees}
                    onChange={e =>
                      changeCustomerForm("employees", e.target.value)
                    }
                    type="number"
                    className={classes.employeesInput}
                    inputProps={{
                      max: 99999,
                      min: 0
                    }}
                  />
                </CBodyCell>
              </CTableRow>

              <CTableRow>
                <CHeadCell>使用可能言語 *</CHeadCell>
                <CBodyCell>
                  <FormGroup row>
                    {allLocales.map(lang => (
                      <FormControlLabel
                        key={lang.id}
                        control={
                          <Checkbox
                            checked={customer.isSelectedLang(lang.id)}
                            onChange={e =>
                              changeSelectedLocales(e.target.value, lang.key)
                            }
                          />
                        }
                        value={`${lang.id}`}
                        label={lang.jaLabel}
                      />
                    ))}
                  </FormGroup>
                </CBodyCell>
              </CTableRow>

              <CTableRow>
                <CHeadCell>メモ</CHeadCell>
                <CBodyCell>
                  <CInput
                    id="customer-memo"
                    value={customer.memo || ""}
                    onChange={e => changeCustomerForm("memo", e.target.value)}
                    multiline
                    rowsMax="5"
                    fullWidth
                    className={classes.memo}
                  />
                </CBodyCell>
              </CTableRow>
            </CTableBody>
          </CTable>
        </DialogContent>

        <DialogActions>
          <Button raised onClick={handleClose}>
            キャンセル
          </Button>
          <Button
            raised
            onClick={() => {
              return customer.isNew()
                ? handleRegister(customer)
                : handleUpdate(customer);
            }}
          >
            {btnLabel}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(CustomerModal);



// WEBPACK FOOTER //
// ./src/components/CustomerModal.jsx